import ContextMenu from './../../gui/context_menu/context_menu';

export function contextMenuHandler($scope, { cnfg, $location, $route, formEditorService, GhElementEditor, GhElementEditorLight, Message, PipeService, $element, localizationService }) {

    const dictionary = localizationService.getDictionary('gh_menus');
    const translate = (word) => localizationService.translate(word, dictionary);

    const findGhElement = (element) => {
        return element.closest('gh-element[field-id], [gh-element][field-id]') || false;
    };

    return async function handleContextMenuEditor(event) {
        if (!$element[0].contains(event.target)) return;
        const appId = $scope.appId || $route.current.params.param_1;
        const app = await gudhub.getAppInfo(appId);
        if ((cnfg.show_context_menu && app.permission == 4) || (cnfg.show_context_menu && app.permission == 3)) {
            event.preventDefault();
            const ghElement = findGhElement(event.target);

            if (ghElement) {
                const ghElementContainerId = ghElement.getAttribute('container-id');
                const ghElementElemSrc = ghElement.getAttribute('elem-src');
                const ghElementFieldId = ghElement.getAttribute('field-id');
                const ghElementItemId = ghElement.getAttribute('item-id');
                const ghElementAppId = ghElement.getAttribute('app-id');

                async function saveChanges(fieldData) {
                    let fieldModel = Object.assign({}, fieldData);
                    delete fieldModel.settings;
                    await gudhub.updateField(ghElementAppId || appId, fieldModel);
                }

                const fieldAddress = {
                    app_id: ghElementAppId || appId,
                    field_id: ghElementFieldId
                };

                const model = await gudhub.getField(fieldAddress.app_id, fieldAddress.field_id) || {};
                const instance = await gudhub.ghconstructor.getInstance(model.data_type);
                if (!instance) {
                    $scope.field_model = formEditorService.getElementModel(fieldAddress.field_id);
                } else {
                    $scope.field_model = instance.getTemplate().model;
                }

                new ContextMenu(event, [{
                    title: translate('Field Configurator'),
                    badge: cnfg.saas_mode ? 'Upgrade' : undefined,
                    events: {
                        click: async function() {
                            if (Object.keys(model).length === 0) {
                                Object.assign(model, $scope.field_model);
                            }
                            model.container_id = ghElementContainerId;
                            GhElementEditor.edit(model, fieldAddress.app_id, ghElementItemId).then(function(fieldData) {
                                if (ghElementAppId) {
                                    saveChanges(fieldData);
                                } else {
                                    var message = new Message({ field_id: 'existing_field_update_' + $scope.$id }, $scope);
                                    message.emit('existing_field_update', { to: { place: 'template_editor' }, value: fieldData });
                                }
                            });
                        }
                    }
                }, {
                    title: translate('Field Style'),
                    badge: cnfg.saas_mode ? 'Upgrade' : undefined,
                    events: {
                        click: function() {
                            GhElementEditor.editStyle(null, model, ghElementElemSrc, ghElementContainerId).then(function(fieldData) {
                                if (ghElementAppId) {
                                    saveChanges(fieldData);
                                } else {
                                    var message = new Message({ field_id: 'existing_field_update_' + $scope.$id }, $scope);
                                    message.emit('existing_field_update', { to: { place: 'template_editor' }, value: fieldData });
                                }
                            });
                        }
                    }
                }, {
                    title: translate('Delete element'),
                    events: {
                        click: function() {
                            if (ghElementAppId) {
                                let appAddress = { app_id: appId };
                                PipeService.on('gh_app_get', appAddress, function getAppPipe(_event, app) {
                                    PipeService.destroy('gh_app_get', appAddress, getAppPipe);
                                    let app_copy = angular.copy(app);
                                    formEditorService.deleteContainerFromView(app_copy.views_list, ghElementContainerId);
                                    PipeService.emit('gh_app_update', {}, { app: app_copy });
                                }).emit('gh_app_get', {}, appAddress);
                            } else {
                                var message = new Message({ container_id: 'container_delete_' + $scope.$id }, $scope);
                                message.emit('container_delete', { to: { place: 'delete' }, value: ghElementContainerId });
                            }
                        }
                    }
                }]);
            } 
        }
    };
}
